import IPayload from "@/interfaces/IPayload";
import api from "./api";
import { resources } from "./resources";
import { ToQueryString } from "@/utils/utils";

class RebateUsina {
    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.rebateUsina}${ToQueryString(filters)}`);
    }

    async getListaErros(id: any) {
        return await api.get(`${resources.rebateUsina}/errors/${id}`);
    }

    async getStatus() {
        return await api.get<any>(`${resources.rebateUsina}/status`);
    }

    async start(data: any) {
        return await api.post<any>(`${resources.rebateUsina}`, data);
    }

    async process(data: any) {
        return await api.post<any>(`${resources.rebateUsina}/Process`, data);
    }

    async approve(data: any) {
        return await api.post<any>(`${resources.rebateUsina}/Approve`, data);
    }

    async reopen(data: any) {
        return await api.post<any>(`${resources.rebateUsina}/Reopen`, data);
    }

    async import(data: any) {
        return await api.post<any>(`${resources.rebateUsina}/Upload`, data);
    }

    async download(filters: any) {
        return await api.get<any>(`${resources.rebateUsina}/Download${ToQueryString(filters)}`);
    }
}

export default new RebateUsina();
